module.exports = __webpack_public_path__ + "img/icone-texte.1f5aff25.png";